/**
 * Finance > Products — F-UnifiedProducts
 *
 * This page is now a thin redirector. The canonical Master Product
 * Registry lives under Products System (P4) at
 * `/admin/products-system/products`. Every CRUD write goes into the
 * single `products` collection, feeding Invoices, POs, Quotations, RFQs
 * and CRM deals from one source of truth.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ArrowRight } from 'lucide-react';

const FinancialProducts = () => {
  const navigate = useNavigate();

  // Auto-redirect after 1.5s so users relinking bookmarks still land correctly.
  useEffect(() => {
    const t = setTimeout(() => {
      navigate('/admin/products', { replace: true });
    }, 1500);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      className="min-h-[60vh] flex items-center justify-center p-6"
      data-testid="finance-products-redirect"
    >
      <div className="max-w-lg bg-white border border-slate-200 rounded-xl shadow-sm p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-[#023E8A]/5 flex items-center justify-center mx-auto mb-4">
          <Package className="w-7 h-7 text-[#023E8A]" />
        </div>
        <h2 className="text-xl font-bold text-[#0F172A] mb-2">
          Products moved to Master Product Registry
        </h2>
        <p className="text-sm text-slate-600 mb-4">
          All products — for Invoices, Quotations, Purchase Orders and CRM
          deals — now live in a single registry. Redirecting you there now…
        </p>
        <button
          type="button"
          onClick={() => navigate('/admin/products', { replace: true })}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#023E8A] text-white text-sm font-semibold hover:bg-[#012a5e]"
          data-testid="finance-products-redirect-btn"
        >
          Go to Master Product Registry <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default FinancialProducts;
